import { Pen } from "lucide-react";

import { Modal } from "@/shared/ui/Modal";

import { TableSearchInput } from "@/features/TableSearchInput/TableSearchInput";
import { useMentorshipsByMentor } from "@/entities/mentorship";
import { useIsolatedPages } from "@/shared/hooks/useIsolatedPages";
import { PAGE_SIZE } from "@/shared/lib/consts";
import { DataTable } from "@/shared/ui/DataTable";
import { MentorshipsColumns } from "./mentorships-columns";

interface ReassignMentorshipsModalProps {
  mentorId: string;
}

export const ReassignMentorshipsModal = ({
  mentorId,
}: ReassignMentorshipsModalProps) => {
  const { page, search, setPage, setSearch } = useIsolatedPages();
  const { data, isFetching, refetch } = useMentorshipsByMentor({
    mentorId,
    currentPage: page,
    pageSize: PAGE_SIZE,
    search,
  });

  return (
    <Modal>
      <Modal.Trigger size="icon">
        <Pen />
      </Modal.Trigger>
      <Modal.Content className="md:min-w-[700px]">
        <Modal.Title>Ученики</Modal.Title>
        <div>
          <TableSearchInput search={search} setSearch={setSearch} />
        </div>
        <DataTable
          data={data?.data.filter(({ student }) => student !== undefined) || []}
          page={page}
          setPage={setPage}
          pageCount={data ? Math.ceil(data.total / PAGE_SIZE) : 0}
          columns={MentorshipsColumns}
          isLoading={isFetching}
          refetch={refetch}
        />
      </Modal.Content>
    </Modal>
  );
};
